angular.module('elidb').filter('phone', function() {
    return function(string) {
    	if(!string) return;
        return string.replace(/(\d{4},)/gim,"$1<br>");
    };
});